import React, { useState } from 'react';
import swal from 'sweetalert';

export const showtoast = (type, message) => {
    let toastElement = document.createElement('div');
    toastElement.innerText = message;
    if (type === 'error') {
        toastElement.classList.add('toast-error-FF');
    }
    toastElement.classList.add('toast-message-FF');
    document.body.appendChild(toastElement);

    setTimeout(function () {
        toastElement.classList.add('fade-out');

        setTimeout(function () {
            document.body.removeChild(toastElement);
        }, 500);
    }, 2000);
} 

export const mySweetAlert = (type, msg) => {
    swal({
        title: '',
        text: msg,
        icon: type,
        buttons: {
            confirm: {
                text: "OK",
                value: true,
                visible: true,
                className: "",
                closeModal: true
            }
        }
    })
}

//export const showModal = (message) => {
//    return (
//        <>
//            <div className="absolute">
//                ${message}
//            </div>
//        </>
//    );
//}


export const ModalComponent = ({ name, phoneNumber, showModal }) => {
    

    

    //const closeModal = () => {
    //    setIsModalVisible(false);
    //};

    return (
        <>
            {showModal && (
                <div className="modal fade show" id="myModal" role="dialog" style={{ display: 'block' }}>
                    <div className="modal-dialog">
                        <div className="modal-content-center">
                            <button type="button" className="close">
                                <img src="~/SwagCreator/images/x.png" alt='' />
                            </button>
                            <div className="congrats-container">
                                <div className="check-icon">
                                    <img src="~/SwagCreator/images/Group 39.png" alt='' />
                                </div>
                                <h2>{name}, {phoneNumber}</h2>
                                <p className="submitted-successfully">Your information has been submitted successfully</p>
                                <p className="submitted-successfully">Our team will reach out to you soon</p>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

